export const LANDING = '/';
export const SIGN_UP = '/';
export const SIGN_IN = '/signin';
export const SIGN_OUT = '/signout';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const ACCOUNT = '/account';
export const FORGOT_PASSWORD = ACCOUNT + '/?mode=forgotPassword';
export const REPORT = '/report/overview';
export const TERMS_OS = '/terms-of-service/';


// WEBPACK FOOTER //
// ./src/constants/routes.js